import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21aef2bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://assets.qiandaocdn.com/admin-upload/a3d69fbb8703c25f435fd925dcd5dc30.jpg!lfit_w1080_jpg",
  class: "background",
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "year-text" }, "2025", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "ta在临界扮演的角色是", -1))
const _hoisted_5 = { class: "role-section" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "role-text" }
const _hoisted_8 = {
  key: 0,
  class: "stats-section"
}
const _hoisted_9 = { class: "stat-item" }
const _hoisted_10 = { class: "stat-item" }
const _hoisted_11 = {
  key: 1,
  class: "stats-section"
}
const _hoisted_12 = { class: "stat-item stat-item-small" }
const _hoisted_13 = {
  key: 2,
  class: "stats-section"
}
const _hoisted_14 = { class: "stat-item" }
const _hoisted_15 = { class: "stat-item" }
const _hoisted_16 = {
  key: 3,
  class: "stats-section"
}
const _hoisted_17 = { class: "stat-item" }
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = {
  key: 4,
  class: "stats-section"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-item" }, "新的一年", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-item" }, "请继续探索临界大陆吧", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://assets.qiandaocdn.com/admin-upload/c6457452dcf768492fe427cf4e26ac73.png",
    alt: "",
    class: "button"
  })
], -1))

import { invokeAppByYYB } from "@/utils/mob";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import NftApi from "@/apis";
import sensors from "@/sensors";
interface UserReport {
  role: string;
  giveLikesCount?: number;
  giveCommentsCount?: number;
}

interface CommissionReport {
  sellingOrderCount?: number;
  sellingOrderCost?: number;
  buyingOrderCount?: number;
  buyingOrderCost?: number;
}

interface TokenReport {
  count?: number;
}

interface CommunityReport {
  postCount?: number;
}

interface ReportData {
  userReport?: UserReport;
  commissionReport?: CommissionReport;
  tokenReport?: TokenReport;
  communityReport?: CommunityReport;
}

type RoleType =
  | "超级稿件囤囤鼠"
  | "笔耕不辍创作者"
  | "产出不停造梦家"
  | "热情社交夸夸机"
  | "一般路过临界居民";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const isWxBrowser = ref(false);
const data = ref<ReportData | null>(null);

const roleMap: Record<RoleType, string> = {
  超级稿件囤囤鼠:
    "https://assets.qiandaocdn.com/admin-upload/81f85b47ad40596f0a85a2f5be46fb6e.png",
  笔耕不辍创作者:
    "https://assets.qiandaocdn.com/admin-upload/f03b057c4d6c948fa847584416e5914e.png",
  产出不停造梦家:
    "https://assets.qiandaocdn.com/admin-upload/ca1c2c3ccf879273e9e214d4d823ea21.png",
  热情社交夸夸机:
    "https://assets.qiandaocdn.com/admin-upload/8664fd64fe87ed37467d7c30cd7a01a5.png",
  一般路过临界居民:
    "https://assets.qiandaocdn.com/admin-upload/651193716680cb47fed9e8043be6b008.png",
};

async function fetchData() {
  const res = await NftApi.getNewyearReport({
    userId: router.currentRoute.value.query.userId,
  });
  data.value = (res.data || res) as ReportData;
}

const isWxBrowserFn = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};

onMounted(async () => {
  document.addEventListener("click", handleClick);
  await fetchData();
  sensors.track("edgy_yearly_report_guest_expose", {
    report_owner_id: router.currentRoute.value.query.userId,
  });
});

isWxBrowser.value = isWxBrowserFn();

function handleClick() {
  invokeAppByYYB({
    targetPath: "hybrid",
    params: {
      url: "https://events.linjieapp.com/yearly-report-2025-linjie?isShowNavigationBar=false",
      linjieEnv: false,
    },
  });
  sensors.track("edgy_yearly_report_guest_click", {
    report_owner_id: router.currentRoute.value.query.userId,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: 
            data.value?.userReport?.role
              ? roleMap[data.value.userReport.role as RoleType] || ''
              : ''
          ,
          alt: "",
          class: "role-image"
        }, null, 8, _hoisted_6),
        _createElementVNode("div", _hoisted_7, _toDisplayString(data.value?.userReport?.role), 1),
        (data.value?.userReport?.role === '笔耕不辍创作者')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, " 售出了" + _toDisplayString(data.value?.commissionReport?.sellingOrderCount) + "份稿位 ", 1),
              _createElementVNode("div", _hoisted_10, " 收获了" + _toDisplayString(data.value?.commissionReport?.sellingOrderCost) + "枚金币 ", 1)
            ]))
          : (data.value?.userReport?.role === '产出不停造梦家')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, " 发布了" + _toDisplayString(data.value?.tokenReport?.count) + "个作品，" + _toDisplayString(data.value?.communityReport?.postCount) + "篇帖子 ", 1)
              ]))
            : (data.value?.userReport?.role === '超级稿件囤囤鼠')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, " 约到了" + _toDisplayString(data.value?.commissionReport?.buyingOrderCount) + "张稿件 ", 1),
                  _createElementVNode("div", _hoisted_15, " 花费了" + _toDisplayString(data.value?.commissionReport?.buyingOrderCost) + "枚金币 ", 1)
                ]))
              : (data.value?.userReport?.role === '热情社交夸夸机')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, " 点赞了" + _toDisplayString(data.value?.userReport?.giveLikesCount) + "作品/帖子 ", 1),
                    _createElementVNode("div", _hoisted_18, " 评论了" + _toDisplayString(data.value?.userReport?.giveCommentsCount) + "作品/帖子 ", 1)
                  ]))
                : (data.value?.userReport?.role === '一般路过临界居民')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
                  : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_23
  ], 64))
}
}

})